<template>
    <div style="height: 100%" v-cloak>
        <div class="breadcrumb-layout" v-if="!hidden">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>公司人员管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="column-layout clearfix" style="height: 100%; overflow: hidden;">
            <div v-cloak class="left-column fl" :class="{'active' : !treeCollapse}">
                <div class="tab-container base">
                    <div class="tabs-nav">
                        <ul class="head">
                            <li class="head-item current">组织机构</li>
                        </ul>
                    </div>
                </div>
                <div id="tree-menu" style="overflow-y: auto;">
                    <swb-org-tree :searchSize="'mini'" :bizUnitIds="bizUnitIds" :bizUnitId="bizUnitId" :isCurrentCom="isCurrentCom" :showIncludeSubComs="true" :isCom="isCom" :bizDepart="true" :isSelectThisLevel="isSelectThisLevel" :enableSearch="true"
                                  @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
                </div>
            </div>
            <div class="right-column fl">
                <div>
                    <div class="tab-container base">
                        <div class="tabs-nav">
                            <ul class="head clearfix">
                                <li class="head-item current">
                                    <a class="font14">员工信息</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tabs-content">
                            <ul class="body" style="padding: 0;">
                                <li class="body-item">
                                    <swb-com-staff-select :comId="comId" :bizUnitFlag="false" :checkBox="checkBox" :selectedIds="selectedIds" :roleIds="roleIds" ref="swb_com_staff_select"></swb-com-staff-select>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {Utils} from '../../app.base'
    import {Vue, Routes} from '../../app.vues'
    import retailerApi from '../../api/retailer'
    //
    import SwbOrgTree from './OrgTree';
    Vue.regist(SwbOrgTree);
    //
    import SwbComStaffSelect from './ComStaffSelect';
    Vue.regist(SwbComStaffSelect);

    //
    export default {
        name: 'swb-com-staff-main-select',
        desc: '公司人员选择',
        props: {
            isCom: {    // 是否获取全部的公司
                type: Boolean,
                default: false
            },
            bizUnitFlag: {    // 是否获取全部的公司
                type: Boolean,
                default: true
            },
            isSelectThisLevel: { //本级是否可选
                type: Boolean,
                default: false
            },
            defComId: { // 默认显示的公司人员
                type: Number,
                default: null
            },
            hidden: {
                type: Boolean,
                default: false
            },
            isCurrentCom: {
                type: Boolean,
                default: false
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            selectedIds: {
                type: Array,
                default: null
            },
            bizUnitId: {
                type: Number,
                default: null
            },
            bizUnitIds: {
                type: Array,
                default: null
            },
            roleIds: {  // 获取指定岗位下的人员
                type: Array,
                default: null
            }
        },
        data: function () {
            return {
                comId: null,
                comName: null,
                comFullName: null,
                treeCollapse: true,
                includeSubComs: false,
                comLevel: null
            }
        },
        created: function () {
            if (!Utils.isNoB(this.defComId)) {
                this.comId = this.defComId;
                this.getComInfo(this.comId);
            }
        },
        mounted: function () {
            //
        },
        methods: {
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                //let theLoad = MsgBox.loading();
                retailerApi.getRetailerCom(postData, function (result) {
                    if (result != null) {
                        if (result.type == 'info') {
                            let com = result.data;
                            self.comName = com.name;
                        } else {
                            MsgBox.warning(result.message);
                        }
                    }
                });
            },
            notityChange: function (eventData) {
                this.comId = eventData.id;
                this.comName = eventData.name;
                this.comFullName = eventData.fullName;
                if (eventData.orgType == 0) {
                    this.isCom = true;
                } else {
                    this.isCom = false;
                }
                // this.bizUnitId = eventData.bizUnitId;
                this.includeSubComs = eventData.includeSubComs;
                this.comLevel = eventData.level;
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            getDlgResult(){
                let result = this.$refs.swb_com_staff_select.getDlgResult() || {};
                result.type = 'info';
                let data = result.data;
                if (Utils.isNoB(data)) {
                    result.type = 'warn';
                    result.message = '请至少选择一个员工';
                    return result;
                }
                data.srcComId = this.comId;
                data.srcComName = this.comName;
                data.srcComFullName = this.comFullName;
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/orgStruct/ComStaffMainSelect.vue